module.exports = __webpack_public_path__ + "img/ic_criticalthinking.7845b279.png";